import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronUp = (props) => {
    return (
        <Icon
            viewBox="0 0 40 40"
            fill="none"
            {...props}
            data-testid="chevron-up"
            aria-hidden="true"
        >
            <path
                id="arrow"
                d="M28 23.9998L20 15.9998L12 23.9998"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default ChevronUp
